module.exports = __webpack_public_path__ + "static/img/Brees-MostGames-Milestone-Selective.49dcb93.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Brees-MostGames-Milestone-Selective.gif
// module id = joOU
// module chunks = 1